module.exports = __webpack_public_path__ + "static/media/accessory23.fbf7490d.webp";